var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "w-100 position-relative d-flex align-items-center" },
    [
      _c(
        "b-form",
        {
          staticClass: "w-100",
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.submitSearch.apply(null, arguments)
            }
          }
        },
        [
          _c("div", { staticClass: "d-flex align-items-center w-100" }, [
            _c("div", { staticClass: "search-box-container" }, [
              _c(
                "div",
                {
                  staticClass: "fake-input-wrapper",
                  class: {
                    clickable: _vm.hideSearch,
                    "is-disabled": _vm.disabledSubmit
                  },
                  on: { click: _vm.onFakeInputClick }
                },
                [
                  _c("b-form-input", {
                    staticClass: "custom-search-input",
                    attrs: {
                      value: _vm.query,
                      disabled: _vm.disabledSubmit,
                      placeholder: _vm.hideSearch ? "Фильтры" : "Поиск...",
                      readonly: _vm.hideSearch,
                      autocomplete: "off"
                    },
                    on: { input: _vm.onInput }
                  }),
                  _vm._v(" "),
                  _vm.filterTags.length
                    ? _c(
                        "div",
                        { staticClass: "tags-container" },
                        _vm._l(_vm.filterTags, function(tag, index) {
                          return _c(
                            "b-badge",
                            {
                              key: index,
                              staticClass: "custom-tag",
                              attrs: { variant: "secondary" }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "text-truncate",
                                  staticStyle: { "max-width": "150px" }
                                },
                                [_vm._v(_vm._s(tag.label))]
                              ),
                              _vm._v(" "),
                              _c("v-icon", {
                                staticClass: "cursor-pointer ml-1",
                                attrs: { name: "buttons/cross", size: 8 },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.$emit("remove-tag", tag)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        }),
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "search-btn",
                  attrs: { type: "button", disabled: _vm.disabledSubmit },
                  on: { click: _vm.handleActionClick }
                },
                [
                  _c("v-icon", {
                    attrs: {
                      name: _vm.hideSearch ? "buttons/filter" : "buttons/search"
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _vm.$slots.default && !_vm.hideSearch
              ? _c(
                  "div",
                  { staticClass: "ml-auto" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "custom-btn-secondary",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.toggleOpen.apply(null, arguments)
                          }
                        }
                      },
                      [
                        _c("v-icon", {
                          staticClass: "mr-1",
                          attrs: { name: "buttons/filter", size: 11 }
                        }),
                        _vm._v("\n          Фильтр\n        ")
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("transition", { attrs: { name: "flyout" } }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isOpen,
                    expression: "isOpen"
                  }
                ],
                staticClass: "filters-flyout"
              },
              [
                _c(
                  "b-card",
                  {
                    staticClass:
                      "shadow-lg h-100 d-flex flex-column overflow-hidden",
                    attrs: { "no-body": "", "bg-variant": "light" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "px-3 py-2 border-bottom rounded-top d-flex justify-content-between align-items-center flex-shrink-0"
                      },
                      [
                        _c("h5", { staticClass: "mb-0" }, [_vm._v("Фильтр")]),
                        _vm._v(" "),
                        _c(
                          "b-button",
                          {
                            staticClass: "text-dark p-0",
                            attrs: { size: "sm", variant: "link" },
                            on: { click: _vm.toggleOpen }
                          },
                          [
                            _c("font-awesome-icon", {
                              attrs: { icon: "times" }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "px-3 pb-2 pt-1 flyout-body bg-white overflow-auto flex-grow-1"
                      },
                      [_c("b-row", [_vm._t("default")], 2)],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "px-3 py-2 border-top rounded-bottom d-flex justify-content-between align-items-center flex-shrink-0"
                      },
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "text-danger p-0",
                            attrs: { variant: "link", size: "sm" },
                            on: { click: _vm.onClear }
                          },
                          [_vm._v("Очистить")]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-button",
                          {
                            staticClass: "custom-btn-primary",
                            attrs: { disabled: _vm.disabledSubmit },
                            on: { click: _vm.submitSearch }
                          },
                          [_vm._v("Найти")]
                        )
                      ],
                      1
                    )
                  ]
                )
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1aff5e27", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1aff5e27","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!/home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/utilites/commonUi/FiltersDrawer.vue
// module id = null
// module chunks = 